/**
 * Image Utils
 *
 * Shared utility helpers used across the image picker modules.
 */

import { translator } from "../../../translation/translator";

class ImageUtils {
    public static preventDefaults(event: Event): void {
        event.preventDefault();
        event.stopPropagation();
    }

    public static getTranslation(key: string, fallback: string): string {
        return translator?.getTranslation(key) || fallback;
    }
}

export { ImageUtils };
